import gsap from 'gsap';

const open = gsap.timeline({
    paused: true,
    onStart: function() {
        $('.header__toggle').addClass('collapse--active');
        $('html').addClass('no-scroll');
    },
});

open
    .to('.collapse--menu', {
        opacity: 1,
        ease: 'easeInOut',
        display: 'block',
        width: '100%',
        x: 0,
        height: '100dvh',
        duration: 0.4,
    })
    .to('.collapse__content__menu > li', {
        opacity: 1,
        visibility: 'visible',
        // stagger: 0.1,
        duration: 0.4,
    }, '-=0.1');

const close = gsap.timeline({
    paused: true,
    defaults: { clearProps: true },
    onComplete: function() {
        $('.header__toggle').removeClass('collapse--active');
        $('html').removeClass('no-scroll');
    },
});

close
    .to('.collapse--menu', {
        opacity: 0,
        ease: 'easeInOut',
        display: 'none',
        width: '4rem',
        transform: 'translate(1.9rem, 0.6rem)',
        height: '4rem',
        duration: 0.2,
    });

const timelineToggle = (timeline) => {
    if( timeline.progress() < 1 ) {
        timeline.play();
    } else {
        timeline.restart();
    }
}

$('.header__toggle').on('click', function() {
    if( $(this).hasClass('collapse--active')) {
        timelineToggle(close);
    } else {
        timelineToggle(open);
    }
});
